import {RequestActionsConstant} from "./RequestActionsConstant";
import RequestBase from "./RequestBase";

export default class AuthenticationRequest extends RequestBase {
    public constructor(
        public readonly authToken: string,
        public readonly tid: string | undefined
    ) {
        super();
        this.action = RequestActionsConstant.AUTH;
    }
}
